/* eslint-disable */
import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { GetTokenApi, getUserApi } from "../api/Api";

function RedirectWechat() {
	const navigate = useNavigate();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		console.log(urlParams, "urlParams");

		const code = urlParams.get("code");
		console.log(code, "code");

		const state = urlParams.get("state");
		console.log(state, "state");

		// getToken(code);

		return window.parent && window.parent.postMessage(code, "*");
	}, []);

	const getToken = async (code: any) => {
		try {
			const res = (await GetTokenApi({ code: code })) as any;

			if (res?.token) {
				localStorage.setItem("token", res?.token);
				getUserData();
			}
		} catch (e) {
			console.log(e);
		}
	};

	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
				navigate("/d5data");
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
	};

	return <></>;
}

export default RedirectWechat;
